import {
  AiOutlineDashboard,
  AiOutlineDollar,
  AiOutlineToTop,
  AiOutlineWallet
} from "react-icons/ai";
import { BiTransfer } from "react-icons/bi";
import { FaMoneyBillWave } from "react-icons/fa";
import { FiLogOut, FiUser } from "react-icons/fi";
import { GiAchievement, GiTakeMyMoney } from "react-icons/gi";
import { IoWalletOutline } from "react-icons/io5";
import { MdOutlineSupportAgent, MdOutlineVolunteerActivism } from "react-icons/md";
import { RiTeamLine } from "react-icons/ri";
export const menus = [
  {
    id: "337fdkf",
    menu: "dashboard",
    icon: <AiOutlineDashboard />,
    route: "/",
  },
  {
    id: "f8df5df",
    menu: "add funds",
    icon: <IoWalletOutline />,
    route: "/add-funds",
  },
  {
    id: "d8s4f55",
    menu: "transaction history",
    icon: <AiOutlineDollar />,
    route: "/transaction-history",
  },
  {
    id: "7dfser8srf",
    menu: "user profile",
    icon: <FiUser />,
    dropdown: [
      {
        id: "8389r4ifd",
        menu: "my profile",
        route: "/user/my-profile",
      },
      {
        id: "f7d8e8sfrw",
        menu: "update profile",
        route: "/user/update-profile",
      },
      {
        id: "d7f8wer8s",
        menu: "update wallet",
        route: "/user/update-wallet",
      },
      {
        id: "f7se8r5sd5f",
        menu: "update password",
        route: "/user/update-password",
      },
    ],
  },
  {
    id: "f7df8sfd7f",
    menu: "my wallet",
    icon: <AiOutlineWallet />,
    dropdown: [
      {
        id: "7s5fs5jyu6euj",
        menu: "edit wallet",
        route: "/wallet/edit-wallet",
      },
      {
        id: "fd7d8s48574",
        menu: "txn history",
        route: "/wallet/txn-wallet",
      },
    ],
  },
  {
    id: "df79er8suf",
    menu: "my team",
    icon: <RiTeamLine />,
    dropdown: [
      {
        id: "r3er8re8sdf7dn",
        menu: "my tree",
        route: "/team/my-tree",
      },
      {
        id: "fs7erw55s",
        menu: "direct team",
        route: "/team/direct-team",
      },
      {
        id: "s7er9ers5f4s5",
        menu: "my downline",
        route: "/team/my-downline",
      },
    ],
  },
  {
    id: "fsfsfusf8se4r",
    menu: "earnings",
    icon: <GiTakeMyMoney />,
    dropdown: [
      {
        id: "7f9sufsd",
        menu: "direct bonus",
        route: "/earnings/direct-bonus",
      },
      {
        id: "f7d8s5re5s",
        menu: "matching bonus",
        route: "/earnings/matching-bonus",
      },
      {
        id: "fesoifsfu",
        menu: "ROI bonus",
        route: "/earnings/roi-bonus",
      },
      {
        id: "f7se8r57rf",
        menu: "level bonus",
        route: "/earnings/level-bonus",
      },
      {
        id: "e7rfs5fsenbv",
        menu: "generation bonus",
        route: "/earnings/generation-bonus",
      },
      {
        id: "f7fbcbc4f5d",
        menu: "auto pool bonus",
        route: "/earnings/auto-pool-bonus",
      },
      {
        id: "eurvvdfksk",
        menu: "manager comm. bonus",
        route: "/earnings/manager-comm-bonus",
      },
      {
        id: "f7erfserp",
        menu: "account statement",
        route: "/earnings/account-statement",
      },
    ],
  },
  {
    id: "mvkofsfosf",
    menu: "top up",
    icon: <AiOutlineToTop />,
    dropdown: [
      {
        id: "fndfhsorf",
        menu: "topup account",
        route: "/topup/topup-account",
      },
      {
        id: "vnzsdajiodf8",
        menu: "topup history",
        route: "/topup/topup-history",
      },
      {
        id: "vnnxmsofdf7s",
        menu: "my topup history",
        route: "/topup/my-topup-history",
      },
    ],
  },
  {
    id: "bvsrews7sf",
    menu: "funds transfer",
    icon: <BiTransfer />,
    dropdown: [
      {
        id: "vvmkufisf",
        menu: "transfer funds",
        route: "/funds/transfer-funds",
      },
      {
        id: "vnsff7s7f7d",
        menu: "txn history",
        route: "/funds/txn-history",
      },
    ],
  },
  {
    id: "vnnvsfssl",
    menu: "activation wallet",
    icon: <MdOutlineVolunteerActivism />,
    dropdown: [
      {
        id: "vxfflgfi",
        menu: "transfer funds",
        route: "/activationWallet/transfer-funds",
      },
      {
        id: "vvmvksfurf",
        menu: "transfer funds to user",
        route: "/activationWallet/transfer-funds-to-user",
      },
      {
        id: "vmjserfrf5f5",
        menu: "txn history",
        route: "/activationWallet/txn-history",
      },
    ],
  },
  {
    id: "vnhsfer7s8",
    menu: "withdraw",
    icon: <FaMoneyBillWave />,
    dropdown: [
      {
        id: "vnserffsf7s7f",
        menu: "withdraw funds",
        route: "/withdraw/withdraw-funds",
      },
      {
        id: "vnserr43w",
        menu: "reports status",
        route: "/withdraw/reports-status",
      },
    ],
  },
  {
    id: "vnser78ser",
    menu: "my reward",
    icon: <GiAchievement />,
    route: "/reward",
  },
  {
    id: "vnesurusf7",
    menu: "support",
    icon: <MdOutlineSupportAgent />,
    dropdown: [
      {
        id: "vmjdfsf8sf",
        menu: "support ticket",
        route: "/support/support-ticket",
      },
      {
        id: "vmjderusf7s7",
        menu: "ticket history",
        route: "/support/ticket-history",
      },
    ],
  },
  {
    id: "vneruwsf7s",
    menu: "logout",
    icon: <FiLogOut />,
  },
];
